import { atom } from "recoil";

export const anexoAtom = atom<any[]>({
  key: 'anexos',
  default: [],
});
